const pattern = /^\d{6,8}[-|(\s)]{0,1}\d{4}$/;
export default function (value) {
    return pattern.test(value);
}